function initInfiniteScroll() {
  const $collectionWrapper = document.querySelector(".collection.page-width");
  if (!$collectionWrapper) return;

  const $infiniteScroll = $collectionWrapper.querySelector("#infinite-scroll");
  const $productsGrid = $collectionWrapper.querySelector("ul.product-grid");
  if (!$infiniteScroll || !$productsGrid) return;

  const $loader = $infiniteScroll.querySelector(".loader");

  function loadNextPage() {
    console.log("intersecting and loading next page...");
    const { nextPaginationUrl } = $infiniteScroll.dataset;
    fetch(nextPaginationUrl)
      .then((response) => response.text())
      .then((data) => {
        const $htmlPage = new DOMParser().parseFromString(data, "text/html");
        const $nextPageProductsGrid =
          $htmlPage.querySelector("ul.product-grid");
        const nextPageProducts = Array.from($nextPageProductsGrid.children);
        let currentScroll = Math.abs(document.body.getBoundingClientRect().y);
        console.log(currentScroll, "here current scroll");
        nextPageProducts.forEach(($newProduct) =>
          $productsGrid.appendChild($newProduct)
        );
        // unbobserving the paginate component to reobserve it after cards are appended to prevent pagination stuck behavior
        observer.unobserve($infiniteScroll);
        window.scrollTo(0, currentScroll);
        // reobserving the paginate component incase it's still visible in the viewport after the cards are appended
        observer.observe($infiniteScroll);
        const imagesList = Array.from(
          $nextPageProductsGrid.querySelectorAll("img[data-src]")
        );
        initLazyload(imagesList); // Essa função é declarada no global.js

        updatePagination($nextPageProductsGrid);
      });
  }

  function updatePagination($nextPageProductsGrid) {
    const $nextPageInfiniteScroll =
      $nextPageProductsGrid.parentNode.querySelector("#infinite-scroll");
    const { nextPaginationUrl } = $nextPageInfiniteScroll.dataset;
    if (nextPaginationUrl) {
      // ainda não é a última página
      $infiniteScroll.setAttribute(
        "data-next-pagination-url",
        nextPaginationUrl
      );
      return;
    }
    finishInfiniteScroll(); // é a última página
  }

  function finishInfiniteScroll() {
    $infiniteScroll.removeAttribute("data-next-pagination-url");
    $loader.style.display = "";
    $loader.classList.add("hidden");
    observer.unobserve($infiniteScroll);
  }

  function handleObserver(entries) {
    if (entries[0].isIntersecting) loadNextPage();
  }

  const offset = 100;
  const intersectionOptions = {
    root: null,
    rootMargin: offset + "px",
    threshold: 0.1,
  };

  const observer = new IntersectionObserver(
    handleObserver,
    intersectionOptions
  );

  observer.observe($infiniteScroll);
}

initInfiniteScroll();
